import { CurrencyE67Enum, InstallmentsEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { Col, Form, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

const currencyOptions = Object.values(CurrencyE67Enum).map((value) => ({
  value,
  label: value
}))

export const AmountFields = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const {
    currencyProps,
    guaranteedAmountProps,
    premiumProps,
    installmentsProps
  } = formProps(t)

  const installmentsOptions = Object.values(InstallmentsEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      label: t(`installment_${value}`),
      value: value as number
    }))

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={6}>
        <Form.Item {...guaranteedAmountProps} rules={[required]}>
          <InputParsedNumber
            className="w-full"
            placeholder={guaranteedAmountProps.label}
            min={0.01}
            precision={2}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={6}>
        <Form.Item {...premiumProps} rules={[required]}>
          <InputParsedNumber
            className="w-full"
            placeholder={premiumProps.label}
            min={0.01}
            precision={2}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={6}>
        <Form.Item {...currencyProps} rules={[required]}>
          <Select placeholder={currencyProps.label} options={currencyOptions} />
        </Form.Item>
      </Col>

      <Col xs={24} lg={6}>
        <Form.Item {...installmentsProps} rules={[required]}>
          <Select
            placeholder={installmentsProps.label}
            options={installmentsOptions}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
